<template>
	<div :id="id" style="height: 500px;"></div>
</template>

<script>

export default {
  name: 'ParteMapa',

  data: () => ({
		mapa: null,
		marcador: null,
		id: `mapa${Math.round(Math.random()*1000000)}`
	}),

	props: {
		value: {
			type: Object,
			default: function() {
				return {
					coordenadas: {
						latitud: 4.6532724,
						longitud: -74.083836
					},
					distancia: 16
				}
			}
		}
	},

	created: function() {
		this.$nextTick().then(() => {
			this.mapa = L.map(this.id).setView([this.value.coordenadas.latitud, this.value.coordenadas.longitud], this.value.distancia)
			this.marcador = L.marker([this.value.coordenadas.latitud, this.value.coordenadas.longitud]).addTo(this.mapa)
			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
			}).addTo(this.mapa)

			this.mapa.on('moveend', e => {
				this.actualizarUbicación()
			})
		})
	},

	methods: {
		actualizarUbicación: function() {
			let cdnds = this.mapa.getCenter()
			this.value.distancia = this.mapa.getZoom()
			this.value.coordenadas.latitud = cdnds.lat
			this.value.coordenadas.longitud = cdnds.lng
			this.marcador.setLatLng(cdnds)
			console.log(this.value.coordenadas, this.value.distancia)
		},
	}

};

</script>
